module.exports = __webpack_public_path__ + "media/4x3/fm-59c5190c.svg";